import run from '../../utilities/run';
import $ from 'jquery';
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import AsnStore from '../../stores/AsnStore';

run("#asn-detail-page", ()=>{

 const validator = $(".address-validation-form").validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  });

  validator.settings.ignore = ":disabled,:hidden";
  
  const el = $("#asn-detail-page");
  const els = {};
  const fixAddressBtn = "#order-detail-fix-add-btn";
  const asn = $("#asn-detail-page").data("asn");
  const cmrAddress = $("#asn-detail-page").data("facility-info");
  const cmrAddresses = $("#asn-detail-page").data("addresses");
  const validateAddressUrl = $("#asn-detail-page").data("validate-address-url");
  const pageReloadUrl = $("#asn-detail-page").data("asn-detail-page-reload-url");
  const generalErrorMessage = $("#asn-detail-page").data("general-error-message");
  const addressOriginSubTitleText = $("#asn-detail-page").data("add-validation-origin-fac-title-text");

  const elementsMap = {
    destinationSectionPencil: ".destination-section-pecil",
    contentSectionPencil: ".contents-section-pencil",
    servicesSectionPencil: ".services-section-pencil",
    shippingSectionPencil: ".shipping-section-pencil",
    packingSectionPencil: ".packing-section-pencil",
    cancelShipmentBtn: "#asn-detail-cancel-shipment",
    editShipmentBtn: "#asn-detail-edit-shipment",
    pencilIcon: ".fa-pencil",
    returnToShipmentsBtn: "#asn-detail-return-to-shipments",
    printLabelsBtn: "#asn-detail-print-labels",
    printFedExLabelsBtn:  "#asn-detail-print-fedex-label",
    printBolBtn: "#asn-detail-print-bol",
    asnServiceLookupPagingArea: "#asn-detail-service-paging-area",
    asnServiceLookupMainArea: "#asn-detail-service-main-area tbody",
    asnPackingLookupPagingArea: "#asn-detail-packing-paging-area",
    asnPackingLookupMainArea: "#asn-detail-packing-main-area",
    asnProductLookupMainArea :"#asn-detail-product-main-area",
    asnProductLookupPagingArea :"#asn-detail-product-paging-area",
    modifyAddressSection :"modify-address-section"
  };

  setElementsFromScope(els, elementsMap, el);

  const originFacAddress = $("#origin-fac-address");
  const originFacAddressWrapper = $("#origin-fac-address-wrapper");
	const countries = $("#asn-detail-page").data("countries");
	let senderSelecedAddress = "";

  $(fixAddressBtn).click(function() {
		showModal();
		showLoadingModal();
		if(asn.asnStatus == "Error") {
			addressValidation();
			$(".origin-enter-address-item").show();
			$(".origin-modified-address-item").hide();
			$(".origin-validated-address-item").hide();
			$(".modified-invalid-address-section").hide();
		}
  });

  function addressValidation(){
  	let namespace = "";
  	namespace = $("#asn-detail-page").data('namespace');
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				asnId: asn.asnId,
				[`${namespace}callType`]: "addressValidation"
			},
			success: function(data){
				if(data.response == "success") {					
					addressFoundModalOrg(data, cmrAddress, "validated");							
				} 
			},
			error: function(){
        	hideModal();
				alert(generalErrorMessage);
			}
		});
	}

	function addressFoundModalOrg(data, cmrAddress, action) {
			let userAddHtml = "";
			if(data == null) {
				userAddHtml += cmrAddress.cadLocationName + ", " + asn.asnAddressLine1;
				if(!empty(asn.asnAddressLine2)) {
					userAddHtml += ", "+asn.asnAddressLine2+", "+asn.asnCity+", "+asn.asnState+", "+asn.asnZipcode+", "+asn.asnCountry;
				} else {
					userAddHtml += ", "+asn.asnCity+", "+asn.asnState+", "+asn.asnZipcode+", "+asn.asnCountry;
				}
			} else {
				userAddHtml += cmrAddress.cadLocationName + ", " + data.asnAddressLine1;
				if(!empty(data.asnAddressLine2)) {
					userAddHtml += ", "+data.asnAddressLine2+", "+data.asnCity+", "+data.asnState+", "+data.asnZipcode+", "+data.asnCountry;
				} else {
					userAddHtml += ", "+data.asnCity+", "+data.asnState+", "+data.asnZipcode+", "+data.asnCountry;
				}
			}

			if(action == "validated"){
				$("#add-validation-origin-user-entered-add").html(userAddHtml);
			}else{
				$("#add-validation-origin-system-modified-add").html(userAddHtml);
			}
			let sysAddHtml = cmrAddress.cadLocationName.toUpperCase() + ", " + cmrAddress.cadAddress1;
			if(!empty(cmrAddress.cadAddress2)) {
				sysAddHtml += ", "+cmrAddress.cadAddress2+", "+cmrAddress.cadCity+", "+cmrAddress.cadState+", "+cmrAddress.cadZipcode+", "+cmrAddress.cadCountry;
			} else {
				sysAddHtml += ", "+cmrAddress.cadCity+", "+cmrAddress.cadState+", "+cmrAddress.cadZipcode+", "+cmrAddress.cadCountry;
			}

			$("#add-validation-origin-system-found-add").html(sysAddHtml);
			showAddressFoundModal();
	}

  function addressFoundModal(stdAddress1, stdAddress2, stdCity, 
                  stdState, stdZip, stdCountry, data) {
      
      let userAddHtml = "";
      
      if(data == null) {
				userAddHtml += cmrAddress.cadLocationName + "," + asn.asnAddressLine1;

        if(!empty(asn.asnAddressLine2)) {
          userAddHtml += ","+asn.asnAddressLine2+","+asn.asnCity+","+asn.asnState+","+asn.asnZipcode;
        } else {
          userAddHtml += ","+asn.asnCity+","+asn.asnState+","+asn.asnZipcode;
        }
      } else {
				userAddHtml += cmrAddress.cadLocationName + "," + data.address1;
        if(!empty(data.address2)) {
          userAddHtml += ","+data.address2+","+data.city+","+data.state+","+data.zip;
        } else {
          userAddHtml += ","+data.city+","+data.state+","+data.zip;
        }
      }

      $("#add-validation-origin-user-entered-add").html(userAddHtml);
      
	  let sysAddHtml = cmrAddress.cadLocationName.toUpperCase() + "," + stdAddress1;
			
      if(!empty(stdAddress2)) {
        sysAddHtml += ","+stdAddress2+","+stdCity+","+stdState+","+stdZip;
      } else {
        sysAddHtml += ","+stdCity+","+stdState+","+stdZip;
      }

      $("#add-validation-origin-system-found-add").html(sysAddHtml);
      showAddressFoundModal();
	}

	function addressNotFoundModal(data) {

		let userAddHtml = cmrAddress.cadLocationName + "," + data.address1;
		if(!empty(data.address2)) {
			userAddHtml += ","+data.address2+","+data.city+","+data.state+","+data.zip;
		} else {
			userAddHtml += ","+data.city+","+data.state+","+data.zip;
		}
		
		$("#add-validation-user-entered-add").html(userAddHtml);
		showAddressNotFoundModal();
	}

	$('.mod-address-btn').click(function(){
		let namespace = "";
  	    namespace = $("#asn-detail-page").data('namespace');
    	showLoadingModal();
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				asnId: asn.asnId,
				[`${namespace}callType`]: "modifyAddress"
			},
			success: function(data){
				if(data.response == "success") {
					const countries = data.countries;
						
					$('#validate-address-country').empty();
					let option = $('<option />');
					option.attr('value', '').text("Select Country");
					$('#validate-address-country').append(option);
					$(countries).each(function() {
						option = $('<option />');
						option.attr('value', this.conCode).text(this.conName);
						$('#validate-address-country').append(option);
					});

					let userAddHtml = data.asnAddressLine1;
					if(!empty(data.asnAddressLine2)) {
						userAddHtml += ","+data.asnAddressLine2+","+data.asnCity+","+data.asnState+","+data.asnZipcode+", "+data.asnCountry;
					} else {
						userAddHtml += ","+data.asnCity+","+data.asnState+","+data.asnZipcode+", "+data.asnCountry;
					}
	
					$("#add-validation-origin-user-entered-add-modified").html(userAddHtml);
					showModifyAddressModal();
				} 
			},
			error: function(){
        	hideModal();
				alert(generalErrorMessage);
			}
		});
	});

	$('.select-saved-address-btn').click(function(){
		let namespace = "";
  	    namespace = $("#asn-detail-page").data('namespace');
    	showLoadingModal();
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				asnId: asn.asnId,
				[`${namespace}callType`]: "selectFromSavedFacility"
			},
			success: function(data){
				if(data.response == "success") {
					const facilities = data.orgFacilities;
						
					$('#validate-origin-facility').empty();
					let option = $('<option />');
					option.attr('value', '').text("Select origin facility");
					$('#validate-origin-facility').append(option);
					$(facilities).each(function() {
						option = $('<option />');
						option.attr('value', this.cadId).text(this.cadLocationName);
						$('#validate-origin-facility').append(option);
					});

					showSelectFromSavedFacilitiesModal();
				} 
			},
			error: function(){
        	hideModal();
				alert(generalErrorMessage);
			}
		});
	});

	$('#validate-address-country').change(function(){
		const countryVal = $("#validate-address-country :selected").val();
		setStatesFromCountry(countryVal, this.selectedIndex);
	});

	function setStatesFromCountry(countryVal, selectedIndex) {
    if(countryVal == "US" || countryVal == "CA") {
			$(".validate-address-state-text-wrapper").hide();
			$(".validate-address-state-wrapper").show();
			window.print_state("validate-address-state", selectedIndex);
		} else {
			$(".validate-address-state-text-wrapper").show();
			$(".validate-address-state-wrapper").hide();
		}
	}
	
	$('#validate-origin-facility').change(function() {
	const selectedValue = this.value;
    const senderAddress = cmrAddresses.filter(function(obj) { return obj.cadId==selectedValue; })[0];
		senderSelecedAddress = senderAddress;
    originFacAddressWrapper.hide();
    originFacAddress.html('');
    if (senderAddress != null) {
      originFacAddress.append("<div>"+senderAddress.cadAddress1+"</div>");
      if(senderAddress.cadAddress2 != null){
        originFacAddress.append("<div>"+senderAddress.cadAddress2+"</div>");
      }
      if(senderAddress.cadCity == null){
        originFacAddress.append("<div>"+senderAddress.cadState+" "+senderAddress.cadZipcode+"</div>");
      }else{
        originFacAddress.append("<div>"+senderAddress.cadCity+", "+senderAddress.cadState+" "+senderAddress.cadZipcode+"</div>");
      }
	    
      $(countries).each(function() {
        if(this.conCode == senderAddress.cadCountry){
          originFacAddress.append("<div data-concode='"+this.conCode+"'>"+this.conName+"</div>");
          return;
        }
      });
      originFacAddressWrapper.show();
    }
  });

	$('.use-selected-address-btn').click(function(){
		let namespace = "";
  	    namespace = $("#asn-detail-page").data('namespace');
    	showLoadingModal();
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				asnId: asn.asnId,
				userSelectedAdd: $('[name=originRadioAddressChoice]:checked').val(),
				[`${namespace}callType`]: "usethisAddress"
			},
			success: function(data){
				if(data.response == "success" &&
						data.isAddFixed) {
					location.href=(pageReloadUrl);
				} 
			},
			error: function(){
        		hideModal();
				alert(generalErrorMessage);
			}
		});
	});

	$('.set-origin-fac-address-btn').click(function(){
		let selectFromSavedFacilityId = "";
		let namespace = "";
		namespace = $("#asn-detail-page").data('namespace');
		showLoadingModal();
		let addressString = "";
		if($('[name=originRadioAddressChoice]:checked').val() == "0"){
			addressString = $('#add-validation-origin-user-entered-add').text();
		}else if($('[name=originRadioAddressChoice]:checked').val() == "2"){
			addressString = $('#add-validation-origin-system-modified-add').text();
		}else if($('[name=originRadioAddressChoice]:checked').val() == "3"){
			addressString = $('#add-validation-origin-system-validated-add').text();
		}else if($('[name=originRadioAddressChoice]:checked').val() == "4"){
			addressString = $('#add-validation-origin-system-found-add').text();
		}
		
		if(senderSelecedAddress.cadAddress1 != null){
			addressString = senderSelecedAddress.cadLocationName+ ", "+senderSelecedAddress.cadAddress1;
			if(senderSelecedAddress.cadAddress2 != null){
				addressString += ", "+senderSelecedAddress.cadAddress2;
			}
			addressString += ", "+senderSelecedAddress.cadCity+", "+senderSelecedAddress.cadState+", "+senderSelecedAddress.cadZipcode+", "+senderSelecedAddress.cadCountry;
			selectFromSavedFacilityId = senderSelecedAddress.cadId;
		}
		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				asnId: asn.asnId,
				[`${namespace}userSelectedAdd`]: $('[name=originRadioAddressChoice]:checked').val(),
				[`${namespace}callType`]: "setOriginFacAddress",
				[`${namespace}addressString`]: addressString,
				[`${namespace}selectFromSavedFacilityId`]: selectFromSavedFacilityId
			},
			success: function(data){
				if(data.response == "success") {
					hideModal();
					location.href=(pageReloadUrl);
				} 
			},
			error: function(){
        		hideModal();
				alert(generalErrorMessage);
			}
		});
	});
  
	  $('.validate-address-btn').click(function(){
		let namespace = "";
		namespace = $("#asn-detail-page").data('namespace');
		
		if(!validator.elements().valid()) {
		  return;
		}    
		showLoadingModal();    
		const conCode = $("#validate-address-country :selected").val();
		let stateValue = "";
		if(conCode == "US" || conCode == "CA") {
		  stateValue = $("#validate-address-state :selected").val();
		} else {
		  stateValue = $("#validate-address-state-text").val();
		}

		$.ajax({
			url: validateAddressUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				[`${namespace}asnId`]: $('#asnId').val(),
				[`${namespace}country`]: conCode,
				[`${namespace}address1`]: $("#validate-address-address1").val(),
				[`${namespace}address2`]: $("#validate-address-address2").val(),
				[`${namespace}city`]: $("#validate-address-city").val(),
				[`${namespace}state`]: stateValue,
				[`${namespace}zip`]: $("#validate-address-zip").val(),
				[`${namespace}callType`]: "validateThisAddress"
			},
			success: function(data){
				if(data.response == "success") {	
					let userModAddHtml = "";				
					showModal();
					userModAddHtml += cmrAddress.cadLocationName + ", " + $("#validate-address-address1").val();				
					if(!empty($("#validate-address-address2").val())) {
						userModAddHtml += ", "+$("#validate-address-address2").val()+", "+$("#validate-address-city").val()+", "+stateValue+", "+$("#validate-address-zip").val()+", "+$("#validate-address-country").val();
					} else {
						userModAddHtml += ", "+$("#validate-address-city").val()+", "+stateValue+", "+$("#validate-address-zip").val()+", "+$("#validate-address-country").val();
					}
					$("#add-validation-origin-system-modified-add").html(userModAddHtml);
					showAddressFoundModal();
					if(conCode == "US"){
						if(data.validateUsAddress.validateResult){
							$(".origin-enter-address-item").hide();
							$(".origin-modified-address-item").show();
							$(".origin-validated-address-item").show();
							let userValidatedAddHtml = "";
							userValidatedAddHtml += cmrAddress.cadLocationName + ", " + data.validateUsAddress.stdAddress1;
							if(!empty(data.validateUsAddress.stdAddress2)){
								userValidatedAddHtml += ", "+data.validateUsAddress.stdAddress2 + ", " + data.validateUsAddress.stdCity + ", " + data.validateUsAddress.stdState + ", " + data.validateUsAddress.stdZip + ", " + data.validateUsAddress.stdCountry;
							}else{
								userValidatedAddHtml += ", "+data.validateUsAddress.stdCity + ", " + data.validateUsAddress.stdState + ", " + data.validateUsAddress.stdZip + ", " + data.validateUsAddress.stdCountry;
							}
							$("#add-validation-origin-system-validated-add").html(userValidatedAddHtml);
							$(".modified-invalid-address-section").hide();
						}else{
							$(".modified-invalid-address-section").show();
							$(".origin-enter-address-item").hide();
							$(".origin-modified-address-item").show();
						}
					}else{
						$(".origin-enter-address-item").hide();
						$(".origin-modified-address-item").show();
					}
				}
			},
			error: function(){
        		hideModal();
				alert(generalErrorMessage);
			}
		});
	});
  
  function showLoadingModal(){
	$("#address-found-or-not-text").html("");
	$(".add-validation").hide();
	$(".origin-add-validation").show();
    $(".address-select-choices-outer").hide();
    $(".address-validation-loading-outer").show();
	$(".cancel-btn").show();
	$(".mod-address-btn").show();
	$(".select-saved-address-btn").show();
	$(".set-origin-fac-address-btn").show();
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").hide();
  }

  function showModal() {
    $("#add-validation-model").modal("show");
  }

  function hideModal() {
    $("#add-validation-model").modal("hide");
  }
  
  function showAddressFoundModal() {

    $("#address-found-or-not-text").html(addressOriginSubTitleText);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
    }
    if($("#origin-radio-entered-address").hasClass("q-radio-hide")) {
      $("#origin-radio-entered-address").removeClass("q-radio-hide");
    }
    $(".address-select-choices-outer").show();
	$(".found-address-item").hide();
	$(".origin-found-address-item").show();
	$(".enter-address-item").hide();
	$(".origin-enter-address-item").show();
    $(".modify-address-section").hide();
	$(".select-from-facility-state").hide();
    $(".no-address-found-section").hide();
    $(".address-validation-loading-outer").hide();
	$(".mod-address-btn").show();
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").hide();
  }
  
  function showAddressNotFoundModal() {
    $("#address-found-or-not-text").html(addressOriginSubTitleText);
    if($("#radio-entered-address").hasClass("q-radio-hide")) {
      $("#radio-entered-address").removeClass("q-radio-hide");
    }
    if($("#origin-radio-entered-address").hasClass("q-radio-hide")) {
      $("#origin-radio-entered-address").removeClass("q-radio-hide");
    }
    $(".address-select-choices-outer").show();
		$(".found-address-item").hide();		
		$(".origin-found-address-item").hide();
		$(".enter-address-item").hide();
		$(".origin-enter-address-item").hide();
    $(".modify-address-section").hide();
		$(".select-from-facility-state").hide();
    $(".no-address-found-section").show();
    $(".address-validation-loading-outer").hide();
		$(".mod-address-btn").show();
    $(".use-selected-address-btn").hide();
    $(".validate-address-btn").hide();
  }
  
  function showModifyAddressModal() {
		$("#address-found-or-not-text").html(addressOriginSubTitleText);
		$("#radio-entered-address").addClass("q-radio-hide");
		$("#origin-radio-entered-address").addClass("q-radio-hide");
		$(".address-select-choices-outer").show();
		$(".found-address-item").hide();		
		$(".origin-found-address-item").hide();
		$(".enter-address-item").hide();
		$(".origin-enter-address-item").hide();
		$(".modify-address-section").show();
		$(".select-from-facility-state").hide();
		$(".no-address-found-section").hide();
		$(".address-validation-loading-outer").hide();
		$(".mod-address-btn").hide();
		$(".use-selected-address-btn").hide();
		$(".validate-address-btn").show();
		$(".set-origin-fac-address-btn").hide();
		$(".origin-modified-address-item").hide();
		$(".origin-validated-address-item").hide();
		$(".modified-invalid-address-section").hide();
   }
	function showSelectFromSavedFacilitiesModal() {
		$("#address-found-or-not-text").html(addressOriginSubTitleText);
		$("#radio-entered-address").addClass("q-radio-hide");
		$(".address-select-choices-outer").show();
		$(".found-address-item").hide();		
		$(".origin-found-address-item").hide();
		$(".enter-address-item").hide();
		$(".origin-enter-address-item").hide();
		$(".modify-address-section").hide();
		$(".select-saved-address-btn").hide();
		$(".select-from-facility-state").show();
		$(".no-address-found-section").hide();
		$(".address-validation-loading-outer").hide();
		$(".mod-address-btn").show();
		$(".use-selected-address-btn").hide();
		$(".validate-address-btn").hide();
		$(".origin-modified-address-item").hide();
		$(".origin-validated-address-item").hide();
		$(".modified-invalid-address-section").hide();
		originFacAddressWrapper.hide();
		originFacAddress.html('');
	}
  
	function empty(str) {
	    if (typeof str == 'undefined' || !str || str.length === 0 || str === "" ||
	    		!/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g,"") === "") {
	        return true;
      } else {
	        return false;
	    }
	}
});


// WEBPACK FOOTER //
// ./src/pages/asns/detailAddressValidation.js